import { memo } from 'react';
import { MdFileDownload } from 'react-icons/md';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ButtonPrimary, TableHeading } from '../../../../../components';
import { SET_IS_OPEN } from '../../../../../reducers/ipa/priceManager/modals/changePrices';
import { useEditedPriceManagerStore } from '../../../../../store/priceManagerStore';
import AppyPricesButton from '../AppyPricesButton/AppyPricesButton';
import { GerenciadorQuickActionFilters } from '../GerenciadorQuickActionFilters';
import SelectAllButton from '../SelectAllButton/SelectAllButton';
import useGerenciadorTableHeading from './useGerenciadorTableHeading';

type GerenciadorTableHeadingProps = ReturnType<typeof mapDispatchToProps>;

const GerenciadorTableHeading = ({ openChangePricesModal }: GerenciadorTableHeadingProps) => {
  const {
    total,
    isFiltersEmpty,
    isEmptySelectedDatapoints,
    handleSelectAllFromAllPages,
    handleUnselectAllFromAllPages,
    handleDownloadSelectedData,
    isDownloadLoading,
  } = useGerenciadorTableHeading();
  const { isPendingEditedPrice } = useEditedPriceManagerStore();

  return (
    <TableHeading isSelected={!isEmptySelectedDatapoints}>
      <TableHeading.Container>
        <TableHeading.TotalProducts total={total} />
        <SelectAllButton isEmpty={isFiltersEmpty} handleSelectAllFromAllPages={handleSelectAllFromAllPages} handleUnselectAll={handleUnselectAllFromAllPages} />
      </TableHeading.Container>
      <TableHeading.Container>
        {isEmptySelectedDatapoints && <GerenciadorQuickActionFilters />}
        {!isEmptySelectedDatapoints && (
          <>
            <ButtonPrimary
              id="download-dados"
              style={{ background: '#EAEAEA' }}
              skin="gray"
              disabled={isEmptySelectedDatapoints}
              isLoading={isDownloadLoading}
              onClick={handleDownloadSelectedData}
            >
              <MdFileDownload size={20} color="#959595" />
            </ButtonPrimary>
            <ButtonPrimary id="alterar-precos" theme="ghost" skin="blue" disabled={isPendingEditedPrice} onClick={openChangePricesModal}>
              ALTERAR PREÇO
            </ButtonPrimary>
          </>
        )}
        <AppyPricesButton />
      </TableHeading.Container>
    </TableHeading>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  openChangePricesModal: () => dispatch(SET_IS_OPEN(true)),
});

export default memo(connect(null, mapDispatchToProps)(GerenciadorTableHeading));
